import Scene from './Scene';
import common from '../common';

/**
 * This is very much a fake loading scene that loads absolutely nothing.
 * All it'll do is wait a few seconds and then remove itself, so that the game in the background can generate correctly
 * (e.g. particles need to play for a few seconds so they dont come out as squares)
 */
export default class FakeLoadingScene extends Scene {
	constructor() {
		super();

		this.loaded = {t: 0};

		this._preloaderFill = null;
		this._preloaderMask = null;
	}

	init() {
		super.init();

		const preloaderBG = new PIXI.Sprite(P3.assets.texture('ui_loader_bg'));
		preloaderBG.anchor.set(0.5);
		preloaderBG.position.set(common.STAGE_WIDTH * 0.5, (common.STAGE_HEIGHT * 0.5));
		this.addChild(preloaderBG);

		this._preloaderFill = new PIXI.Sprite(P3.assets.texture('ui_loader_fill'));
		this._preloaderFill.anchor.set(0.5);
		this._preloaderFill.position.set(common.STAGE_WIDTH * 0.5, (common.STAGE_HEIGHT * 0.5));
		this.addChild(this._preloaderFill);

		this._preloaderMask = new PIXI.Graphics();
		this._preloaderMask.beginFill(0xFF0000);
		this._preloaderMask.drawRect(0, 0, this._preloaderFill.width, this._preloaderFill.height);
		this._preloaderMask.endFill();
		this.addChild(this._preloaderMask);
		this._preloaderMask.position.set(0, this._preloaderFill.y - (this._preloaderFill.height * 0.5));

		this._preloaderFill.mask = this._preloaderMask;

		new P3.utils.TWEEN.Tween(this.loaded, this.tweens)
			.to({
				t: 1
			}, 2000)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.onUpdate(() => {
				this._preloaderMask.x = (this._preloaderFill.width * this.loaded.t) + this._preloaderFill.width + 27;
			})
			.onComplete(() => {
				this.signals.next.dispatch();
			})
			.start();
	}

	destroy() {
		super.destroy();
	}

	update() {
		super.update();
	}
}
